/**
 * System > 운영 환경 > DNS 설정
 *
 * @since 2021-10-28
 * @author wj-tams-dev1
 */

import {SystemApiPrefix as smApiPrefix} from '~/utils/restApi'
import compareObject from '~/utils/compare'

export const state = () => ({
  apiUrlPath: {
    // connect: '/api/co/tools/connect',
    dnsServers: `${smApiPrefix}/dns`, // GET, POST, DELETE{dns_serv_id}
    dns: `${smApiPrefix}/dns/config`, // GET, POST
    dnsApply: `${smApiPrefix}/dns/apply`,
    dnsCancel: `${smApiPrefix}/dns/cancel`
  },
  // check status of connect
  connectStatus: {
    code: 'nok',
    result: {
      connect: false
    }
  },
  warningPageDataList: [],
  dialogMode: '',
  dialogTitleName: '',
  dialogFooterButton: [],
  dialogParam: [],
  selectedItem: {},
  // common responseData
  resResultData: {reqType: '', resStatus: 404, resCode: 'nok', resMessage: ''},
  // dns-config
  dnsConfig: {domain_name: ''},
  dnsConfigIp: {
    dns_serv_id: 0,
    dns_serv_dns_ip: null,
    dns_serv_dns_ip_ver_type: 1
  },
  dnsConfigIpList: [],
  // request dns
  reqDnsConfig: {
    domain_name: '',
    ip_list: []
  },
  // // split dns
  // splitDnsDefault: {
  //   enable: 0,
  //   type: 0
  // },
  // // ddns
  // ddnsStatusData: {
  //   status: ''
  // },
  // ddnsConfigData: {
  //   enable: 0,
  //   period: 0
  // },
  // ddnsHostData: {
  //   host_index: 0,
  //   host_name: '',
  //   service_supplier: '',
  //   id: '',
  //   passwd: '',
  //   ssl_enable: 0,
  //   desc: ''
  // },
  // ddnsHostListData: [],
  // ## clone object for compare
  // dns
  dnsConfigClone: {
    domain_name: ''
  },
  // // split dns
  // splitDnsConfigClone: {
  //   enable: 0
  // },
  // // ddns
  // ddnsConfigClone: {
  //   enable: 0,
  //   period: 0
  // },
  // compare test
  testSplitClone: {enable: 0},
  testSplit: {enable: 0},
  service_supplierOptions: [
    {label: 'Dyndns', value: 0},
    {label: 'ZoneEdit', value: 1},
    {label: 'EasyDNS', value: 2},
    {label: 'DtDNS', value: 3},
    {label: 'Namecheap', value: 4},
    {label: 'NoIP', value: 5},
    {label: 'FreeDNS', value: 6}
  ]
})

export const mutations = {
  // ha url
  setHaPrefix (state, apiPrefix) {
    const reSmApiPrefix = `${smApiPrefix.substring(1, smApiPrefix.length)}/`

    state.apiUrlPath.connect = `${apiPrefix}api/co/tools/connect`
    state.apiUrlPath.dns = `${apiPrefix}${reSmApiPrefix}dns/config`
    state.apiUrlPath.dnsServers = `${apiPrefix}${reSmApiPrefix}dns`
    state.apiUrlPath.dnsApply = `${apiPrefix}${reSmApiPrefix}dns/apply`
    state.apiUrlPath.dnsCancel = `${apiPrefix}${reSmApiPrefix}dns/cancel`
  },
  // check status-connect(sync)
  resetConnectStatus (state) {
    state.connectStatus = {
      code: 'nok',
      result: {
        connect: false
      }
    }
  },
  setConnectStatus (state, data) {
    // state.connectStatus.code = data.code
    state.connectStatus.result.connect = data.connect
  },
  // rest result of response.
  resetResultResponse (state) {
    state.resResultData = {
      reqType: '',
      resStatus: 404,
      resCode: 'nok',
      resMessage: ''
    }
  },
  // reset dns-config
  resetDnsConfigData (state) {
    state.dnsConfig = {
      domain_name: ''
    }
    state.dnsConfigIp = {
      dns_serv_id: 0,
      dns_serv_dns_ip: null,
      dns_serv_dns_ip_ver_type: 1
    }
    state.reqDnsConfig = {
      domain_name: ''
    }
  },
  resetDnsServersData (state) {
    state.dnsConfigIpList = []
  },
  resetDnsConfigIpData (state) {
    state.dnsConfigIp = {
      dns_serv_id: 0,
      dns_serv_dns_ip: null,
      dns_serv_dns_ip_ver_type: 1
    }
  },
  // reset ddns-status
  // resetDdnsStatusData (state) {
  //   state.ddnsStatusData = {
  //     status: ''
  //   }
  // },
  // reset ddns-config
  // resetDdnsConfigData (state) {
  //   state.ddnsConfigData = {
  //     enable: 0,
  //     period: 0
  //   }
  // },
  // reset ddns-config
  // resetDdnsConfigHostData (state) {
  //   state.ddnsHostData = {
  //     host_index: 0,
  //     host_name: '',
  //     service_supplier: 0,
  //     id: '',
  //     passwd: '',
  //     ssl_enable: 0,
  //     desc: ''
  //   }
  // },
  // set dns config
  setDnsConfigData (state, data) {
    if (!_.isNil(data.domain_name)) {
      state.dnsConfig.domain_name = data.domain_name || ''
      // copy clone
      state.dnsConfigClone.domain_name = _.cloneDeep(data.domain_name || '')
    }
  },
  setDnsServersData (state, data) {
    state.dnsConfigIpList = data
  },
  edtDnsConfigData (state, data) {
    if (!_.isNil(data.domain_name)) {
      state.dnsConfig.domain_name = data.domain_name
      // copy clone
      state.dnsConfigClone.domain_name = _.cloneDeep(data.domain_name)
    }
  },
  // add dns-config ip_list
  addDnsConfigIpListData (state, data) {
    if (data !== undefined) {
      state.dnsConfigIpList.push(data)
    }
  },
  // delete dns-config ip_list
  delDnsConfigIpListData (state, itemIndexList) {
    if (itemIndexList !== null && itemIndexList !== undefined) {
      itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
      for (const item of itemIndexList) {
        state.dnsConfigIpList.splice(item.itemIndex, 1)
      }
    }
  }
  // set dns-config
  // setDnsConfigDialog (state, setPopup) {
  //   state.dialogMode = setPopup.mode
  //   state.dialogTitleName = setPopup.title
  //   state.dialogFooterButton = setPopup.btnArr
  //   state.dialogParam = (setPopup.param !== undefined) ? setPopup.param : []
  //   if (setPopup.data !== null && setPopup.data !== undefined) {
  //     // case: edit
  //     if (setPopup.type === 'dDns') {
  //       state.selectedItem = setPopup.data
  //       state.ddnsHostData.host_index = setPopup.data.host_index
  //       state.ddnsHostData.host_name = setPopup.data.host_name
  //       state.ddnsHostData.service_supplier = setPopup.data.service_supplier
  //       state.ddnsHostData.id = setPopup.data.id
  //       // not get
  //       state.ddnsHostData.passwd = '' // setPopup.data.passwd
  //       state.ddnsHostData.ssl_enable = setPopup.data.ssl_enable
  //       state.ddnsHostData.desc = setPopup.data.desc
  //     } else if (setPopup.type === 'splitDns') {
  //       // ..
  //     }
  //   }
  // },
  // clear dialog
  // clrDnsConfigDialog (state, setPopup) {
  //   // clear dialog info
  //   state.selectedItem = ''
  //   if (setPopup.name === 'ddns') {
  //     state.ddnsHostData.host_index = 0
  //     state.ddnsHostData.host_name = ''
  //     state.ddnsHostData.service_supplier = ''
  //     state.ddnsHostData.passwd = ''
  //     state.ddnsHostData.id = ''
  //     state.ddnsHostData.ssl_enable = 0
  //     state.ddnsHostData.desc = ''
  //   }
  // },
  // set ddns status data
  // setDdnsStatusData (state, data) {
  //   if (data !== undefined && data.status !== undefined) {
  //     state.ddnsStatusData.status = data.status
  //   }
  // },
  // set result of ddns configData
  // setDdnsConfigData (state, statusData) {
  //   if (statusData !== undefined) {
  //     state.ddnsConfigData.enable = statusData.enable
  //     state.ddnsConfigData.period = statusData.period
  //     // copy clone
  //     state.ddnsConfigClone.enable = _.cloneDeep(statusData.enable)
  //     state.ddnsConfigClone.period = _.cloneDeep(statusData.period)
  //   }
  // },
  // setDdnsHostData (state, data) {
  //   if (data !== undefined) {
  //     state.ddnsHostListData = data
  //   }
  // },
  // edtDdnsConfigData (state, data) {
  //   if (data !== undefined) {
  //     state.ddnsConfigData.enable = data.enable
  //     state.ddnsConfigData.period = data.period
  //   }
  // },
  // add ddns host data
  // addDdnsHostData (state, data) {
  //   if (data !== null) {
  //     state.ddnsHostListData.push(data)
  //   }
  // },
  // // edit ddns host data
  // edtDdnsHostData (state, item) {
  //   const findRslt = _.find(state.ddnsHostListData, {host_index: item.host_index})
  //   if (findRslt !== undefined && findRslt.itemIndex !== undefined) {
  //     state.ddnsHostListData.splice(_.findIndex(state.ddnsHostListData, state.selectedItem), 1, item)
  //   }
  // },
  // // delete ddns host data
  // delDdnsHostData (state, itemIndexList) {
  //   if (itemIndexList !== null && itemIndexList !== undefined) {
  //     itemIndexList = _.orderBy(itemIndexList, ['itemIndex'], ['desc'])
  //     for (const item of itemIndexList) {
  //       state.ddnsHostListData.splice(item.itemIndex, 1)
  //     }
  //   }
  // }
}

export const actions = {
  // ha set
  async setHaPrefixAction ({commit, state}, param) {
    commit('setHaPrefix', param)
  },
  // get result of connect-status
  async getConnectStatus ({commit, state}, apiUrl) {
    const res = {code: 'nok'}
    const {code, result} = await this.$axios.$get(`${state.apiUrlPath.connect}?target=${encodeURIComponent(apiUrl)}`)
    if (code !== undefined && (code).toLowerCase() === 'ok') {
      res.code = 'ok'
      commit('resetConnectStatus')
      commit('setConnectStatus', result)
    } else {
      res.code = 'nok'
    }
    return res
  },
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> dns config start.
  // get interfaces data.
  async getDnsConfigData ({commit, state}) {
    commit('resetDnsConfigData')
    try {
      const {code, result} = await this.$axios.$get(state.apiUrlPath.dns)
      if (code !== undefined && (code).toLowerCase() === 'ok') {
        commit('setDnsConfigData', result)
      }
    } catch (e) {
      // Test Code Start
      // const data = {code: 'ok', result: {domain_name: '123'}}
      // commit('setDnsConfigData', data.result)
      // Test Code End
    }
  },
  // get dns servers
  async getDnsServersData ({commit, state}) {
    try {
      const {code, result} = await this.$axios.$get(state.apiUrlPath.dnsServers)
      if (code !== undefined && (code).toLowerCase() === 'ok') {
        commit('resetDnsServersData')
        commit('setDnsServersData', result)
      }
    } catch (e) {
      // Test Code Start
      // const data = {code: 'ok', result: [{index: 1, ip: '111.111.111.111', version: 4}]}
      // commit('resetDnsServersData')
      // commit('setDnsServersData', data.result)
      // Test Code End
    }
  },
  // modifyDnsConfig data (PUT: domain)
  async modifyDnsConfig ({commit, state}) {
    const res = { code: 'ok' }
    try {
      state.reqDnsConfig.domain_name = _.cloneDeep(state.dnsConfig.domain_name)

      const {code, result} = await this.$axios.$post(state.apiUrlPath.dns, state.reqDnsConfig)
      if (code === 'ok') {
        commit('edtDnsConfigData', result)
      } else {
        res.code = 'nok'
      }
      res.result = result
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e
      return res
    }
  },
  // set dns-config data.
  async addDnsConfigIpData ({commit, state}, continued) {
    const res = { code: 'ok' }
    try {
      const {code, result} = await this.$axios.$post(
        state.apiUrlPath.dnsServers,
        state.dnsConfigIp,
        {
          loading: false,
          successAlert: false
        })

      if (code === 'ok') {
        res.result = result
        if (!continued) {
          commit('resetDnsConfigIpData')
        }
      } else {
        res.code = 'nok'
        res.result = result
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e
      return res
    }
  },
  // delete dns config ip_list
  async delDnsConfigIpData ({commit, state}, param) {
    const res = { code: 'ok' }
    const delItemIndexList = []
    for (const idx of param.idList) {
      const rslt = await this.$axios.$delete(`${state.apiUrlPath.dnsServers}/${idx.dns_serv_id}`)

      if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
        delItemIndexList.push({itemIndex: idx.itemIndex})
      } else {
        res.code = 'nok'
      }
    }
    commit('delDnsConfigIpListData', delItemIndexList)

    return res
  },
  // dns apply & cancel
  async applyDnsConfig ({commit, state}, loadingOpt) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(state.apiUrlPath.dnsApply, null, loadingOpt)
      if (code !== undefined && (code).toLowerCase() === 'ok') {
        res.reason = result
        // commit common isChanage
        this.dispatch('common/common/setIsChanged', false)
      } else {
        res.code = 'nok'
      }
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e
      return res
    }
  },
  async cancelDnsConfig ({commit, state}, loadingOpt) {
    const res = {code: 'ok'}
    try {
      const {code, result} = await this.$axios.$put(state.apiUrlPath.dnsCancel, null, loadingOpt)
      if (code !== undefined && (code).toLowerCase() === 'ok') {
        res.reason = result
        // commit common isChanage
        this.dispatch('common/common/setIsChanged', false)
      } else {
        res.code = 'nok'
      }
      // reset dns config
      // this.dispatch('getDnsConfigData')
      return res
    } catch (e) {
      res.code = 'nok'
      res.reason = e
      return res
    }
  }
  // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<< dns config end.
  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ddns config start.
  // get ddns config
  // async getDdnsConfigData ({commit, state}) {
  //   commit('resetDdnsConfigData')
  //   const {code, result} = await this.$axios.$get(state.apiUrlPath.ddns)
  //   if (code === 'ok') {
  //     commit('setDdnsConfigData', result)
  //   }
  // },
  // async edtDdnsConfigData ({commit, state}) {
  //   const res = {code: 'ok'}
  //   const putParam = {
  //     enable: state.ddnsConfigData.enable,
  //     period: state.ddnsConfigData.period
  //   }
  //   const {code, result} = await this.$axios.$put(state.apiUrlPath.ddns, putParam, {
  //     successAlert: false,
  //     loading: false,
  //     loadingShow: false,
  //     loadingHide: false
  //   })
  //   if (code !== undefined && (code).toLowerCase() === 'ok') {
  //     commit('setDdnsConfigData', result)
  //     // commit common isChanage
  //     this.dispatch('common/common/setIsChanged', true)
  //   } else {
  //     res.code = 'nok'
  //   }
  //   return res
  // },
  // get ddns status
  // async getDdnsStatusData ({commit, state}) {
  //   const res = {code: 'ok'}
  //   commit('resetDdnsStatusData')
  //   const {code, result} = await this.$axios.$get(state.apiUrlPath.ddnsStatus)
  //   if (code !== undefined && (code).toLowerCase() === 'ok') {
  //     commit('setDdnsStatusData', result)
  //   } else {
  //     res.code = 'nok'
  //   }
  //   return res
  // },
  // get ddns host data
  // async getDdnsHostData ({commit, state}) {
  //   commit('resetDdnsConfigHostData')
  //   const {code, result} = await this.$axios.$get(state.apiUrlPath.ddnsHosts)
  //   if (code !== undefined && (code).toLowerCase() === 'ok') {
  //     commit('setDdnsHostData', result)
  //   }
  // },
  // set dns-config data.
  // async addDdnsHostData ({commit, state}, continued) {
  //   const res = { code: 'ok' }
  //   try {
  //     const postParam = _.cloneDeep(state.ddnsHostData)
  //     // base64 for password
  //     postParam.passwd = btoa(postParam.passwd)
  //     const {code, result} = await this.$axios.$post(state.apiUrlPath.ddnsHosts, postParam)
  //     if (code !== undefined && (code).toLowerCase() === 'ok') {
  //       commit('addDdnsHostData', result)
  //       if (!continued) {
  //         commit('resetDdnsConfigHostData')
  //       }
  //       // commit common isChanage
  //       this.dispatch('common/common/setIsChanged', true)
  //
  //       return res
  //     }
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.reason = e
  //     return res
  //   }
  // },
  // async editDdnsHostData ({commit, state}) {
  //   const res = { code: 'ok' }
  //   try {
  //     const url = `${state.apiUrlPath.ddnsHosts}/${state.ddnsHostData.host_index}`
  //     const putParam = _.cloneDeep(state.ddnsHostData)
  //     if ((putParam.passwd).length === 0) {
  //       delete putParam.passwd
  //     } else {
  //       // base64 for password ( only modify password )
  //       putParam.passwd = btoa(putParam.passwd)
  //     }
  //     const {code, result} = await this.$axios.$put(url, putParam)
  //     if (code !== undefined && (code).toLowerCase() === 'ok') {
  //       commit('edtDdnsHostData', result)
  //       // commit common isChanage
  //       this.dispatch('common/common/setIsChanged', true)
  //     } else {
  //       res.code = 'nok'
  //     }
  //     return res
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.reason = e
  //     return res
  //   }
  // },
  // async delDdnsHostData ({commit, state}, param) {
  //   const res = { code: 'ok' }
  //   const delParam = {items: []}
  //   for (const idx of param.idList) {
  //     delParam.items.push({host_index: idx.host_index})
  //   }
  //   const rslt = await this.$axios.$delete(`${state.apiUrlPath.ddnsHosts}`, {data: delParam})
  //   if (rslt.code !== undefined && (rslt.code).toLowerCase() === 'ok') {
  //     commit('delDdnsHostData', param.itemIndexList)
  //     // commit common isChanage
  //     this.dispatch('common/common/setIsChanged', true)
  //   } else {
  //     res.code = 'nok'
  //   }
  //   return res
  // },
  // ddns apply & cancel
  // async applyDdnsConfig ({commit, state}, loadingOpt) {
  //   const res = {code: 'ok'}
  //   try {
  //     const {code, result} = await this.$axios.$put(state.apiUrlPath.ddnsApply, null, loadingOpt)
  //     if (code !== undefined && (code).toLowerCase() === 'ok') {
  //       res.reason = result
  //       // commit common isChanage
  //       this.dispatch('common/common/setIsChanged', false)
  //     } else {
  //       res.code = 'nok'
  //     }
  //     return res
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.reason = e
  //     return res
  //   }
  // },
  // async cancelDdnsConfig ({commit, state}, loadingOpt) {
  //   const res = {code: 'ok'}
  //   try {
  //     const {code, result} = await this.$axios.$put(state.apiUrlPath.ddnsCancel, null, loadingOpt)
  //     if (code !== undefined && (code).toLowerCase() === 'ok') {
  //       res.reason = result
  //       // commit common isChanage
  //       this.dispatch('common/common/setIsChanged', false)
  //     } else {
  //       res.code = 'nok'
  //     }
  //     // reset dns config
  //     // this.dispatch('getDdnsConfigData')
  //     return res
  //   } catch (e) {
  //     res.code = 'nok'
  //     res.reason = e
  //     return res
  //   }
  // }
}

export const getters = {
  compareDnsConfigData (state) {
    const dnsCloneProperty = {
      domain_name: state.dnsConfigClone.domain_name
    }
    const dnsProperty = {
      domain_name: state.dnsConfig.domain_name
    }
    return compareObject(dnsCloneProperty, dnsProperty)
  // },
  // compareDdnsConfigData (state) {
  //   const ddnsCloneProperty = {
  //     enable: state.ddnsConfigClone.enable,
  //     period: state.ddnsConfigClone.period
  //   }
  //   const ddnsProperty = {
  //     enable: state.ddnsConfigData.enable,
  //     period: state.ddnsConfigData.period
  //   }
  //   return compareObject(ddnsCloneProperty, ddnsProperty)
  }
}

export const strict = false
